// extracted by mini-css-extract-plugin
export default {"formBanner":"responsiveStyles_formBanner__B0Uk7"};